"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformDatesToTimespan = void 0;
const utils_1 = require("@daytrip/utils");
function transformDatesToTimespan(departureAtFrom, departureAtTo) {
    const formattedDepartureAtFrom = (0, utils_1.transformTimeToString)(departureAtFrom, false, true, false);
    const formattedDepartureAtTo = (0, utils_1.transformTimeToString)(departureAtTo);
    return `${formattedDepartureAtFrom}\xa0-\xa0${formattedDepartureAtTo}`;
}
exports.transformDatesToTimespan = transformDatesToTimespan;
//# sourceMappingURL=transformDatesToTimespan.js.map